const getAccessorColumnDef = (column) => {
    const accessor = column.accessor;
    return {
        id: accessor.toString(),
        accessorKey: accessor,
        header: () => column.header,
        cell: ({ row, getValue }) => {
            const value = getValue();
            return column.cell({
                isEditable: column.isEditable,
                row: row.original,
                rowIndex: row.index,
                value,
            });
        },
        meta: {
            isEditable: column.isEditable,
            headerName: column.headerName ?? (typeof column.header === 'string' ? column.header : undefined),
            hasHeader: !!column.header,
            sticky: column.sticky,
            width: column.width,
        },
    };
};
const getDisplayColumnDef = (column) => {
    const id = column.id;
    return {
        id,
        header: () => column.header,
        cell: ({ row }) => {
            return column.cell({
                isEditable: column.isEditable,
                row: row.original,
                rowIndex: row.index,
                value: undefined,
            });
        },
        meta: {
            isEditable: column.isEditable,
            headerName: column.headerName ?? (typeof column.header === 'string' ? column.header : undefined),
            hasHeader: !!column.header,
            sticky: column.sticky,
            width: column.width,
        },
    };
};
export const getColumnDef = (column) => {
    if ('accessor' in column) {
        return getAccessorColumnDef(column);
    }
    return getDisplayColumnDef(column);
};
export const getColumnId = (column) => {
    return 'accessor' in column ? (column.accessor?.toString() ?? '') : (column.id ?? '');
};
export const getColumnMeta = (column) => {
    return column.columnDef.meta ?? {};
};
//# sourceMappingURL=utils.js.map